import React from 'react';

import { TabItem } from './TabItem';

import './TabList.scss';

export interface TabListItem {
  id: string;
  label: string;
  dataTestId?: string;
}

export interface TabListProps {
  items: TabListItem[];
  activeTab: string;
  onTabClick: (itemId: string) => void;
}

export const TabList: React.FC<TabListProps> = ({ items, activeTab, onTabClick }) => (
  <div className="tab__list">
    {items.map(item => (
      <TabItem
        key={item.id}
        isActive={item.id === activeTab}
        onClick={() => onTabClick(item.id)}
        dataTestId={item.dataTestId}
      >
        {item.label}
      </TabItem>
    ))}
  </div>
);
